module.exports = __webpack_public_path__ + "static/media/Slide16.052ad30b.jpg";